import * as te from "react";
import Zr, { forwardRef as hr, useContext as Lt, Children as or, createContext as Vt } from "react";
import { css as b } from "@emotion/react";
import { LoadingIcon as Mt } from "@illa-design/icon";
import { zIndex as Dr, getColor as u, applyBoxStyle as Xr, deleteCssProps as Qr } from "@illa-design/theme";
var cr = { exports: {} }, xe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function jt() {
  if (Fr)
    return xe;
  Fr = 1;
  var e = Zr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(f, h, v) {
    var p, g = {}, R = null, O = null;
    v !== void 0 && (R = "" + v), h.key !== void 0 && (R = "" + h.key), h.ref !== void 0 && (O = h.ref);
    for (p in h)
      a.call(h, p) && !s.hasOwnProperty(p) && (g[p] = h[p]);
    if (f && f.defaultProps)
      for (p in h = f.defaultProps, h)
        g[p] === void 0 && (g[p] = h[p]);
    return { $$typeof: r, type: f, key: R, ref: O, props: g, _owner: i.current };
  }
  return xe.Fragment = n, xe.jsx = d, xe.jsxs = d, xe;
}
var we = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function Yt() {
  return Lr || (Lr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Zr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), f = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), I = Symbol.iterator, x = "@@iterator";
    function M(t) {
      if (t === null || typeof t != "object")
        return null;
      var o = I && t[I] || t[x];
      return typeof o == "function" ? o : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(t) {
      {
        for (var o = arguments.length, l = new Array(o > 1 ? o - 1 : 0), E = 1; E < o; E++)
          l[E - 1] = arguments[E];
        k("error", t, l);
      }
    }
    function k(t, o, l) {
      {
        var E = _.ReactDebugCurrentFrame, P = E.getStackAddendum();
        P !== "" && (o += "%s", l = l.concat([P]));
        var L = l.map(function(T) {
          return String(T);
        });
        L.unshift("Warning: " + o), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var V = !1, c = !1, Y = !1, A = !1, Je = !1, $e;
    $e = Symbol.for("react.module.reference");
    function Ke(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === s || Je || t === i || t === v || t === p || A || t === O || V || c || Y || typeof t == "object" && t !== null && (t.$$typeof === R || t.$$typeof === g || t.$$typeof === d || t.$$typeof === f || t.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === $e || t.getModuleId !== void 0));
    }
    function Ze(t, o, l) {
      var E = t.displayName;
      if (E)
        return E;
      var P = o.displayName || o.name || "";
      return P !== "" ? l + "(" + P + ")" : l;
    }
    function Ae(t) {
      return t.displayName || "Context";
    }
    function K(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case v:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var o = t;
            return Ae(o) + ".Consumer";
          case d:
            var l = t;
            return Ae(l._context) + ".Provider";
          case h:
            return Ze(t, t.render, "ForwardRef");
          case g:
            var E = t.displayName || null;
            return E !== null ? E : K(t.type) || "Memo";
          case R: {
            var P = t, L = P._payload, T = P._init;
            try {
              return K(T(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, ae = 0, Pe, Ne, he, Se, ye, Ie, ke;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function Xe() {
      {
        if (ae === 0) {
          Pe = console.log, Ne = console.info, he = console.warn, Se = console.error, ye = console.group, Ie = console.groupCollapsed, ke = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ae++;
      }
    }
    function Qe() {
      {
        if (ae--, ae === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, t, {
              value: Pe
            }),
            info: ee({}, t, {
              value: Ne
            }),
            warn: ee({}, t, {
              value: he
            }),
            error: ee({}, t, {
              value: Se
            }),
            group: ee({}, t, {
              value: ye
            }),
            groupCollapsed: ee({}, t, {
              value: Ie
            }),
            groupEnd: ee({}, t, {
              value: ke
            })
          });
        }
        ae < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ve = _.ReactCurrentDispatcher, ge;
    function se(t, o, l) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (P) {
            var E = P.stack.trim().match(/\n( *(at )?)/);
            ge = E && E[1] || "";
          }
        return `
` + ge + t;
      }
    }
    var Ee = !1, oe;
    {
      var er = typeof WeakMap == "function" ? WeakMap : Map;
      oe = new er();
    }
    function y(t, o) {
      if (!t || Ee)
        return "";
      {
        var l = oe.get(t);
        if (l !== void 0)
          return l;
      }
      var E;
      Ee = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = ve.current, ve.current = null, Xe();
      try {
        if (o) {
          var T = function() {
            throw Error();
          };
          if (Object.defineProperty(T.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(T, []);
            } catch (re) {
              E = re;
            }
            Reflect.construct(t, [], T);
          } else {
            try {
              T.call();
            } catch (re) {
              E = re;
            }
            t.call(T.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            E = re;
          }
          t();
        }
      } catch (re) {
        if (re && E && typeof re.stack == "string") {
          for (var C = re.stack.split(`
`), q = E.stack.split(`
`), j = C.length - 1, z = q.length - 1; j >= 1 && z >= 0 && C[j] !== q[z]; )
            z--;
          for (; j >= 1 && z >= 0; j--, z--)
            if (C[j] !== q[z]) {
              if (j !== 1 || z !== 1)
                do
                  if (j--, z--, z < 0 || C[j] !== q[z]) {
                    var J = `
` + C[j].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && oe.set(t, J), J;
                  }
                while (j >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ee = !1, ve.current = L, Qe(), Error.prepareStackTrace = P;
      }
      var fe = t ? t.displayName || t.name : "", kr = fe ? se(fe) : "";
      return typeof t == "function" && oe.set(t, kr), kr;
    }
    function me(t, o, l) {
      return y(t, !1);
    }
    function ce(t) {
      var o = t.prototype;
      return !!(o && o.isReactComponent);
    }
    function ie(t, o, l) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return y(t, ce(t));
      if (typeof t == "string")
        return se(t);
      switch (t) {
        case v:
          return se("Suspense");
        case p:
          return se("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case h:
            return me(t.render);
          case g:
            return ie(t.type, o, l);
          case R: {
            var E = t, P = E._payload, L = E._init;
            try {
              return ie(L(P), o, l);
            } catch {
            }
          }
        }
      return "";
    }
    var Fe = Object.prototype.hasOwnProperty, wr = {}, _r = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var o = t._owner, l = ie(t.type, t._source, o ? o.type : null);
        _r.setExtraStackFrame(l);
      } else
        _r.setExtraStackFrame(null);
    }
    function gt(t, o, l, E, P) {
      {
        var L = Function.call.bind(Fe);
        for (var T in t)
          if (L(t, T)) {
            var C = void 0;
            try {
              if (typeof t[T] != "function") {
                var q = Error((E || "React class") + ": " + l + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw q.name = "Invariant Violation", q;
              }
              C = t[T](o, T, E, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (j) {
              C = j;
            }
            C && !(C instanceof Error) && (Le(P), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", l, T, typeof C), Le(null)), C instanceof Error && !(C.message in wr) && (wr[C.message] = !0, Le(P), m("Failed %s type: %s", l, C.message), Le(null));
          }
      }
    }
    var Et = Array.isArray;
    function rr(t) {
      return Et(t);
    }
    function mt(t) {
      {
        var o = typeof Symbol == "function" && Symbol.toStringTag, l = o && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return l;
      }
    }
    function bt(t) {
      try {
        return Rr(t), !1;
      } catch {
        return !0;
      }
    }
    function Rr(t) {
      return "" + t;
    }
    function Cr(t) {
      if (bt(t))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", mt(t)), Rr(t);
    }
    var be = _.ReactCurrentOwner, xt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Tr, Or, tr;
    tr = {};
    function wt(t) {
      if (Fe.call(t, "ref")) {
        var o = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (o && o.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function _t(t) {
      if (Fe.call(t, "key")) {
        var o = Object.getOwnPropertyDescriptor(t, "key").get;
        if (o && o.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Rt(t, o) {
      if (typeof t.ref == "string" && be.current && o && be.current.stateNode !== o) {
        var l = K(be.current.type);
        tr[l] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(be.current.type), t.ref), tr[l] = !0);
      }
    }
    function Ct(t, o) {
      {
        var l = function() {
          Tr || (Tr = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
        };
        l.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: l,
          configurable: !0
        });
      }
    }
    function Tt(t, o) {
      {
        var l = function() {
          Or || (Or = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
        };
        l.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: l,
          configurable: !0
        });
      }
    }
    var Ot = function(t, o, l, E, P, L, T) {
      var C = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: o,
        ref: l,
        props: T,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return C._store = {}, Object.defineProperty(C._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(C, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.defineProperty(C, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(C.props), Object.freeze(C)), C;
    };
    function $t(t, o, l, E, P) {
      {
        var L, T = {}, C = null, q = null;
        l !== void 0 && (Cr(l), C = "" + l), _t(o) && (Cr(o.key), C = "" + o.key), wt(o) && (q = o.ref, Rt(o, P));
        for (L in o)
          Fe.call(o, L) && !xt.hasOwnProperty(L) && (T[L] = o[L]);
        if (t && t.defaultProps) {
          var j = t.defaultProps;
          for (L in j)
            T[L] === void 0 && (T[L] = j[L]);
        }
        if (C || q) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          C && Ct(T, z), q && Tt(T, z);
        }
        return Ot(t, C, q, P, E, be.current, T);
      }
    }
    var nr = _.ReactCurrentOwner, $r = _.ReactDebugCurrentFrame;
    function ue(t) {
      if (t) {
        var o = t._owner, l = ie(t.type, t._source, o ? o.type : null);
        $r.setExtraStackFrame(l);
      } else
        $r.setExtraStackFrame(null);
    }
    var ar;
    ar = !1;
    function ir(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Ar() {
      {
        if (nr.current) {
          var t = K(nr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function At(t) {
      {
        if (t !== void 0) {
          var o = t.fileName.replace(/^.*[\\\/]/, ""), l = t.lineNumber;
          return `

Check your code at ` + o + ":" + l + ".";
        }
        return "";
      }
    }
    var Pr = {};
    function Pt(t) {
      {
        var o = Ar();
        if (!o) {
          var l = typeof t == "string" ? t : t.displayName || t.name;
          l && (o = `

Check the top-level render call using <` + l + ">.");
        }
        return o;
      }
    }
    function Nr(t, o) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var l = Pt(o);
        if (Pr[l])
          return;
        Pr[l] = !0;
        var E = "";
        t && t._owner && t._owner !== nr.current && (E = " It was passed a child from " + K(t._owner.type) + "."), ue(t), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', l, E), ue(null);
      }
    }
    function Sr(t, o) {
      {
        if (typeof t != "object")
          return;
        if (rr(t))
          for (var l = 0; l < t.length; l++) {
            var E = t[l];
            ir(E) && Nr(E, o);
          }
        else if (ir(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = M(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), T; !(T = L.next()).done; )
              ir(T.value) && Nr(T.value, o);
        }
      }
    }
    function Nt(t) {
      {
        var o = t.type;
        if (o == null || typeof o == "string")
          return;
        var l;
        if (typeof o == "function")
          l = o.propTypes;
        else if (typeof o == "object" && (o.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        o.$$typeof === g))
          l = o.propTypes;
        else
          return;
        if (l) {
          var E = K(o);
          gt(l, t.props, "prop", E, t);
        } else if (o.PropTypes !== void 0 && !ar) {
          ar = !0;
          var P = K(o);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof o.getDefaultProps == "function" && !o.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function St(t) {
      {
        for (var o = Object.keys(t.props), l = 0; l < o.length; l++) {
          var E = o[l];
          if (E !== "children" && E !== "key") {
            ue(t), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", E), ue(null);
            break;
          }
        }
        t.ref !== null && (ue(t), m("Invalid attribute `ref` supplied to `React.Fragment`."), ue(null));
      }
    }
    function Ir(t, o, l, E, P, L) {
      {
        var T = Ke(t);
        if (!T) {
          var C = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (C += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var q = At(P);
          q ? C += q : C += Ar();
          var j;
          t === null ? j = "null" : rr(t) ? j = "array" : t !== void 0 && t.$$typeof === r ? (j = "<" + (K(t.type) || "Unknown") + " />", C = " Did you accidentally export a JSX literal instead of a component?") : j = typeof t, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", j, C);
        }
        var z = $t(t, o, l, P, L);
        if (z == null)
          return z;
        if (T) {
          var J = o.children;
          if (J !== void 0)
            if (E)
              if (rr(J)) {
                for (var fe = 0; fe < J.length; fe++)
                  Sr(J[fe], t);
                Object.freeze && Object.freeze(J);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sr(J, t);
        }
        return t === a ? St(z) : Nt(z), z;
      }
    }
    function It(t, o, l) {
      return Ir(t, o, l, !0);
    }
    function kt(t, o, l) {
      return Ir(t, o, l, !1);
    }
    var Dt = kt, Ft = It;
    we.Fragment = a, we.jsx = Dt, we.jsxs = Ft;
  }()), we;
}
process.env.NODE_ENV === "production" ? cr.exports = jt() : cr.exports = Yt();
var ze = cr.exports;
function zt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Bt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Ut = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(i) {
      var s;
      a.tags.length === 0 ? a.insertionPoint ? s = a.insertionPoint.nextSibling : a.prepend ? s = a.container.firstChild : s = a.before : s = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(i, s), a.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Bt(this));
    var i = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var s = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      s && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !s;
    }
    if (this.isSpeedy) {
      var d = zt(i);
      try {
        d.insertRule(a, d.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', f);
      }
    } else
      i.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), W = "-ms-", Be = "-moz-", N = "-webkit-", yr = "comm", vr = "rule", gr = "decl", Wt = "@import", et = "@keyframes", qt = "@layer", Gt = Math.abs, We = String.fromCharCode, Ht = Object.assign;
function Jt(e, r) {
  return U(e, 0) ^ 45 ? (((r << 2 ^ U(e, 0)) << 2 ^ U(e, 1)) << 2 ^ U(e, 2)) << 2 ^ U(e, 3) : 0;
}
function rt(e) {
  return e.trim();
}
function Kt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function S(e, r, n) {
  return e.replace(r, n);
}
function ur(e, r) {
  return e.indexOf(r);
}
function U(e, r) {
  return e.charCodeAt(r) | 0;
}
function Re(e, r, n) {
  return e.slice(r, n);
}
function X(e) {
  return e.length;
}
function Er(e) {
  return e.length;
}
function Ve(e, r) {
  return r.push(e), e;
}
function Zt(e, r) {
  return e.map(r).join("");
}
var qe = 1, de = 1, tt = 0, G = 0, B = 0, pe = "";
function Ge(e, r, n, a, i, s, d) {
  return { value: e, root: r, parent: n, type: a, props: i, children: s, line: qe, column: de, length: d, return: "" };
}
function _e(e, r) {
  return Ht(Ge("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Xt() {
  return B;
}
function Qt() {
  return B = G > 0 ? U(pe, --G) : 0, de--, B === 10 && (de = 1, qe--), B;
}
function H() {
  return B = G < tt ? U(pe, G++) : 0, de++, B === 10 && (de = 1, qe++), B;
}
function Q() {
  return U(pe, G);
}
function Me() {
  return G;
}
function Oe(e, r) {
  return Re(pe, e, r);
}
function Ce(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function nt(e) {
  return qe = de = 1, tt = X(pe = e), G = 0, [];
}
function at(e) {
  return pe = "", e;
}
function je(e) {
  return rt(Oe(G - 1, fr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function en(e) {
  for (; (B = Q()) && B < 33; )
    H();
  return Ce(e) > 2 || Ce(B) > 3 ? "" : " ";
}
function rn(e, r) {
  for (; --r && H() && !(B < 48 || B > 102 || B > 57 && B < 65 || B > 70 && B < 97); )
    ;
  return Oe(e, Me() + (r < 6 && Q() == 32 && H() == 32));
}
function fr(e) {
  for (; H(); )
    switch (B) {
      case e:
        return G;
      case 34:
      case 39:
        e !== 34 && e !== 39 && fr(B);
        break;
      case 40:
        e === 41 && fr(e);
        break;
      case 92:
        H();
        break;
    }
  return G;
}
function tn(e, r) {
  for (; H() && e + B !== 47 + 10; )
    if (e + B === 42 + 42 && Q() === 47)
      break;
  return "/*" + Oe(r, G - 1) + "*" + We(e === 47 ? e : H());
}
function nn(e) {
  for (; !Ce(Q()); )
    H();
  return Oe(e, G);
}
function an(e) {
  return at(Ye("", null, null, null, [""], e = nt(e), 0, [0], e));
}
function Ye(e, r, n, a, i, s, d, f, h) {
  for (var v = 0, p = 0, g = d, R = 0, O = 0, I = 0, x = 1, M = 1, _ = 1, m = 0, k = "", V = i, c = s, Y = a, A = k; M; )
    switch (I = m, m = H()) {
      case 40:
        if (I != 108 && U(A, g - 1) == 58) {
          ur(A += S(je(m), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += je(m);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += en(I);
        break;
      case 92:
        A += rn(Me() - 1, 7);
        continue;
      case 47:
        switch (Q()) {
          case 42:
          case 47:
            Ve(sn(tn(H(), Me()), r, n), h);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * x:
        f[v++] = X(A) * _;
      case 125 * x:
      case 59:
      case 0:
        switch (m) {
          case 0:
          case 125:
            M = 0;
          case 59 + p:
            _ == -1 && (A = S(A, /\f/g, "")), O > 0 && X(A) - g && Ve(O > 32 ? Mr(A + ";", a, n, g - 1) : Mr(S(A, " ", "") + ";", a, n, g - 2), h);
            break;
          case 59:
            A += ";";
          default:
            if (Ve(Y = Vr(A, r, n, v, p, i, f, k, V = [], c = [], g), s), m === 123)
              if (p === 0)
                Ye(A, r, Y, Y, V, s, g, f, c);
              else
                switch (R === 99 && U(A, 3) === 110 ? 100 : R) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ye(e, Y, Y, a && Ve(Vr(e, Y, Y, 0, 0, i, f, k, i, V = [], g), c), i, c, g, f, a ? V : c);
                    break;
                  default:
                    Ye(A, Y, Y, Y, [""], c, 0, f, c);
                }
        }
        v = p = O = 0, x = _ = 1, k = A = "", g = d;
        break;
      case 58:
        g = 1 + X(A), O = I;
      default:
        if (x < 1) {
          if (m == 123)
            --x;
          else if (m == 125 && x++ == 0 && Qt() == 125)
            continue;
        }
        switch (A += We(m), m * x) {
          case 38:
            _ = p > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            f[v++] = (X(A) - 1) * _, _ = 1;
            break;
          case 64:
            Q() === 45 && (A += je(H())), R = Q(), p = g = X(k = A += nn(Me())), m++;
            break;
          case 45:
            I === 45 && X(A) == 2 && (x = 0);
        }
    }
  return s;
}
function Vr(e, r, n, a, i, s, d, f, h, v, p) {
  for (var g = i - 1, R = i === 0 ? s : [""], O = Er(R), I = 0, x = 0, M = 0; I < a; ++I)
    for (var _ = 0, m = Re(e, g + 1, g = Gt(x = d[I])), k = e; _ < O; ++_)
      (k = rt(x > 0 ? R[_] + " " + m : S(m, /&\f/g, R[_]))) && (h[M++] = k);
  return Ge(e, r, n, i === 0 ? vr : f, h, v, p);
}
function sn(e, r, n) {
  return Ge(e, r, n, yr, We(Xt()), Re(e, 2, -2), 0);
}
function Mr(e, r, n, a) {
  return Ge(e, r, n, gr, Re(e, 0, a), Re(e, a + 1, -1), a);
}
function le(e, r) {
  for (var n = "", a = Er(e), i = 0; i < a; i++)
    n += r(e[i], i, e, r) || "";
  return n;
}
function on(e, r, n, a) {
  switch (e.type) {
    case qt:
      if (e.children.length)
        break;
    case Wt:
    case gr:
      return e.return = e.return || e.value;
    case yr:
      return "";
    case et:
      return e.return = e.value + "{" + le(e.children, a) + "}";
    case vr:
      e.value = e.props.join(",");
  }
  return X(n = le(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function cn(e) {
  var r = Er(e);
  return function(n, a, i, s) {
    for (var d = "", f = 0; f < r; f++)
      d += e[f](n, a, i, s) || "";
    return d;
  };
}
function un(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function fn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var ln = function(r, n, a) {
  for (var i = 0, s = 0; i = s, s = Q(), i === 38 && s === 12 && (n[a] = 1), !Ce(s); )
    H();
  return Oe(r, G);
}, dn = function(r, n) {
  var a = -1, i = 44;
  do
    switch (Ce(i)) {
      case 0:
        i === 38 && Q() === 12 && (n[a] = 1), r[a] += ln(G - 1, n, a);
        break;
      case 2:
        r[a] += je(i);
        break;
      case 4:
        if (i === 44) {
          r[++a] = Q() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += We(i);
    }
  while (i = H());
  return r;
}, pn = function(r, n) {
  return at(dn(nt(r), n));
}, jr = /* @__PURE__ */ new WeakMap(), hn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, i = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !jr.get(a)) && !i) {
      jr.set(r, !0);
      for (var s = [], d = pn(n, s), f = a.props, h = 0, v = 0; h < d.length; h++)
        for (var p = 0; p < f.length; p++, v++)
          r.props[v] = s[h] ? d[h].replace(/&\f/g, f[p]) : f[p] + " " + d[h];
    }
  }
}, yn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, vn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", gn = function(r) {
  return r.type === "comm" && r.children.indexOf(vn) > -1;
}, En = function(r) {
  return function(n, a, i) {
    if (!(n.type !== "rule" || r.compat)) {
      var s = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (s) {
        for (var d = !!n.parent, f = d ? n.parent.children : (
          // global rule at the root level
          i
        ), h = f.length - 1; h >= 0; h--) {
          var v = f[h];
          if (v.line < n.line)
            break;
          if (v.column < n.column) {
            if (gn(v))
              return;
            break;
          }
        }
        s.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, it = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, mn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!it(n[a]))
      return !0;
  return !1;
}, Yr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, bn = function(r, n, a) {
  it(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Yr(r)) : mn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Yr(r)));
};
function st(e, r) {
  switch (Jt(e, r)) {
    case 5103:
      return N + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return N + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return N + e + Be + e + W + e + e;
    case 6828:
    case 4268:
      return N + e + W + e + e;
    case 6165:
      return N + e + W + "flex-" + e + e;
    case 5187:
      return N + e + S(e, /(\w+).+(:[^]+)/, N + "box-$1$2" + W + "flex-$1$2") + e;
    case 5443:
      return N + e + W + "flex-item-" + S(e, /flex-|-self/, "") + e;
    case 4675:
      return N + e + W + "flex-line-pack" + S(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return N + e + W + S(e, "shrink", "negative") + e;
    case 5292:
      return N + e + W + S(e, "basis", "preferred-size") + e;
    case 6060:
      return N + "box-" + S(e, "-grow", "") + N + e + W + S(e, "grow", "positive") + e;
    case 4554:
      return N + S(e, /([^-])(transform)/g, "$1" + N + "$2") + e;
    case 6187:
      return S(S(S(e, /(zoom-|grab)/, N + "$1"), /(image-set)/, N + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return S(e, /(image-set\([^]*)/, N + "$1$`$1");
    case 4968:
      return S(S(e, /(.+:)(flex-)?(.*)/, N + "box-pack:$3" + W + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + N + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return S(e, /(.+)-inline(.+)/, N + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (X(e) - 1 - r > 6)
        switch (U(e, r + 1)) {
          case 109:
            if (U(e, r + 4) !== 45)
              break;
          case 102:
            return S(e, /(.+:)(.+)-([^]+)/, "$1" + N + "$2-$3$1" + Be + (U(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ur(e, "stretch") ? st(S(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (U(e, r + 1) !== 115)
        break;
    case 6444:
      switch (U(e, X(e) - 3 - (~ur(e, "!important") && 10))) {
        case 107:
          return S(e, ":", ":" + N) + e;
        case 101:
          return S(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + N + (U(e, 14) === 45 ? "inline-" : "") + "box$3$1" + N + "$2$3$1" + W + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (U(e, r + 11)) {
        case 114:
          return N + e + W + S(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return N + e + W + S(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return N + e + W + S(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return N + e + W + e + e;
  }
  return e;
}
var xn = function(r, n, a, i) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case gr:
        r.return = st(r.value, r.length);
        break;
      case et:
        return le([_e(r, {
          value: S(r.value, "@", "@" + N)
        })], i);
      case vr:
        if (r.length)
          return Zt(r.props, function(s) {
            switch (Kt(s, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return le([_e(r, {
                  props: [S(s, /:(read-\w+)/, ":" + Be + "$1")]
                })], i);
              case "::placeholder":
                return le([_e(r, {
                  props: [S(s, /:(plac\w+)/, ":" + N + "input-$1")]
                }), _e(r, {
                  props: [S(s, /:(plac\w+)/, ":" + Be + "$1")]
                }), _e(r, {
                  props: [S(s, /:(plac\w+)/, W + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, wn = [xn], _n = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(x) {
      var M = x.getAttribute("data-emotion");
      M.indexOf(" ") !== -1 && (document.head.appendChild(x), x.setAttribute("data-s", ""));
    });
  }
  var i = r.stylisPlugins || wn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var s = {}, d, f = [];
  d = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(x) {
      for (var M = x.getAttribute("data-emotion").split(" "), _ = 1; _ < M.length; _++)
        s[M[_]] = !0;
      f.push(x);
    }
  );
  var h, v = [hn, yn];
  process.env.NODE_ENV !== "production" && v.push(En({
    get compat() {
      return I.compat;
    }
  }), bn);
  {
    var p, g = [on, process.env.NODE_ENV !== "production" ? function(x) {
      x.root || (x.return ? p.insert(x.return) : x.value && x.type !== yr && p.insert(x.value + "{}"));
    } : un(function(x) {
      p.insert(x);
    })], R = cn(v.concat(i, g)), O = function(M) {
      return le(an(M), R);
    };
    h = function(M, _, m, k) {
      p = m, process.env.NODE_ENV !== "production" && _.map !== void 0 && (p = {
        insert: function(c) {
          m.insert(c + _.map);
        }
      }), O(M ? M + "{" + _.styles + "}" : _.styles), k && (I.inserted[_.name] = !0);
    };
  }
  var I = {
    key: n,
    sheet: new Ut({
      key: n,
      container: d,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: s,
    registered: {},
    insert: h
  };
  return I.sheet.hydrate(f), I;
}, lr = { exports: {} }, D = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zr;
function Rn() {
  if (zr)
    return D;
  zr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, m = e ? Symbol.for("react.scope") : 60119;
  function k(c) {
    if (typeof c == "object" && c !== null) {
      var Y = c.$$typeof;
      switch (Y) {
        case r:
          switch (c = c.type, c) {
            case h:
            case v:
            case a:
            case s:
            case i:
            case g:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case p:
                case I:
                case O:
                case d:
                  return c;
                default:
                  return Y;
              }
          }
        case n:
          return Y;
      }
    }
  }
  function V(c) {
    return k(c) === v;
  }
  return D.AsyncMode = h, D.ConcurrentMode = v, D.ContextConsumer = f, D.ContextProvider = d, D.Element = r, D.ForwardRef = p, D.Fragment = a, D.Lazy = I, D.Memo = O, D.Portal = n, D.Profiler = s, D.StrictMode = i, D.Suspense = g, D.isAsyncMode = function(c) {
    return V(c) || k(c) === h;
  }, D.isConcurrentMode = V, D.isContextConsumer = function(c) {
    return k(c) === f;
  }, D.isContextProvider = function(c) {
    return k(c) === d;
  }, D.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, D.isForwardRef = function(c) {
    return k(c) === p;
  }, D.isFragment = function(c) {
    return k(c) === a;
  }, D.isLazy = function(c) {
    return k(c) === I;
  }, D.isMemo = function(c) {
    return k(c) === O;
  }, D.isPortal = function(c) {
    return k(c) === n;
  }, D.isProfiler = function(c) {
    return k(c) === s;
  }, D.isStrictMode = function(c) {
    return k(c) === i;
  }, D.isSuspense = function(c) {
    return k(c) === g;
  }, D.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === v || c === s || c === i || c === g || c === R || typeof c == "object" && c !== null && (c.$$typeof === I || c.$$typeof === O || c.$$typeof === d || c.$$typeof === f || c.$$typeof === p || c.$$typeof === M || c.$$typeof === _ || c.$$typeof === m || c.$$typeof === x);
  }, D.typeOf = k, D;
}
var F = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Br;
function Cn() {
  return Br || (Br = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, m = e ? Symbol.for("react.scope") : 60119;
    function k(y) {
      return typeof y == "string" || typeof y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      y === a || y === v || y === s || y === i || y === g || y === R || typeof y == "object" && y !== null && (y.$$typeof === I || y.$$typeof === O || y.$$typeof === d || y.$$typeof === f || y.$$typeof === p || y.$$typeof === M || y.$$typeof === _ || y.$$typeof === m || y.$$typeof === x);
    }
    function V(y) {
      if (typeof y == "object" && y !== null) {
        var me = y.$$typeof;
        switch (me) {
          case r:
            var ce = y.type;
            switch (ce) {
              case h:
              case v:
              case a:
              case s:
              case i:
              case g:
                return ce;
              default:
                var ie = ce && ce.$$typeof;
                switch (ie) {
                  case f:
                  case p:
                  case I:
                  case O:
                  case d:
                    return ie;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var c = h, Y = v, A = f, Je = d, $e = r, Ke = p, Ze = a, Ae = I, K = O, ee = n, ae = s, Pe = i, Ne = g, he = !1;
    function Se(y) {
      return he || (he = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ye(y) || V(y) === h;
    }
    function ye(y) {
      return V(y) === v;
    }
    function Ie(y) {
      return V(y) === f;
    }
    function ke(y) {
      return V(y) === d;
    }
    function De(y) {
      return typeof y == "object" && y !== null && y.$$typeof === r;
    }
    function Xe(y) {
      return V(y) === p;
    }
    function Qe(y) {
      return V(y) === a;
    }
    function ve(y) {
      return V(y) === I;
    }
    function ge(y) {
      return V(y) === O;
    }
    function se(y) {
      return V(y) === n;
    }
    function Ee(y) {
      return V(y) === s;
    }
    function oe(y) {
      return V(y) === i;
    }
    function er(y) {
      return V(y) === g;
    }
    F.AsyncMode = c, F.ConcurrentMode = Y, F.ContextConsumer = A, F.ContextProvider = Je, F.Element = $e, F.ForwardRef = Ke, F.Fragment = Ze, F.Lazy = Ae, F.Memo = K, F.Portal = ee, F.Profiler = ae, F.StrictMode = Pe, F.Suspense = Ne, F.isAsyncMode = Se, F.isConcurrentMode = ye, F.isContextConsumer = Ie, F.isContextProvider = ke, F.isElement = De, F.isForwardRef = Xe, F.isFragment = Qe, F.isLazy = ve, F.isMemo = ge, F.isPortal = se, F.isProfiler = Ee, F.isStrictMode = oe, F.isSuspense = er, F.isValidElementType = k, F.typeOf = V;
  }()), F;
}
process.env.NODE_ENV === "production" ? lr.exports = Rn() : lr.exports = Cn();
var Tn = lr.exports, ot = Tn, On = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, $n = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ct = {};
ct[ot.ForwardRef] = On;
ct[ot.Memo] = $n;
var An = !0;
function Pn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? r.push(e[i] + ";") : a += i + " ";
  }), a;
}
var ut = function(r, n, a) {
  var i = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  An === !1) && r.registered[i] === void 0 && (r.registered[i] = n.styles);
}, Nn = function(r, n, a) {
  ut(r, n, a);
  var i = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var s = n;
    do
      r.insert(n === s ? "." + i : "", s, r.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function Sn(e) {
  for (var r = 0, n, a = 0, i = e.length; i >= 4; ++a, i -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var In = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Ur = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, kn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Dn = /[A-Z]|^ms/g, ft = /_EMO_([^_]+?)_([^]*?)_EMO_/g, mr = function(r) {
  return r.charCodeAt(1) === 45;
}, Wr = function(r) {
  return r != null && typeof r != "boolean";
}, sr = /* @__PURE__ */ fn(function(e) {
  return mr(e) ? e : e.replace(Dn, "-$&").toLowerCase();
}), Ue = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(ft, function(a, i, s) {
          return Z = {
            name: i,
            styles: s,
            next: Z
          }, i;
        });
  }
  return In[r] !== 1 && !mr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Fn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Ln = ["normal", "none", "initial", "inherit", "unset"], Vn = Ue, Mn = /^-ms-/, jn = /-(.)/g, qr = {};
  Ue = function(r, n) {
    if (r === "content" && (typeof n != "string" || Ln.indexOf(n) === -1 && !Fn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Vn(r, n);
    return a !== "" && !mr(r) && r.indexOf("-") !== -1 && qr[r] === void 0 && (qr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Mn, "ms-").replace(jn, function(i, s) {
      return s.toUpperCase();
    }) + "?")), a;
  };
}
var lt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Te(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(lt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return Z = {
          name: n.name,
          styles: n.styles,
          next: Z
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            Z = {
              name: a.name,
              styles: a.styles,
              next: Z
            }, a = a.next;
        var i = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (i += n.map), i;
      }
      return Yn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var s = Z, d = n(e);
        return Z = s, Te(e, r, d);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], h = n.replace(ft, function(p, g, R) {
          var O = "animation" + f.length;
          return f.push("const " + O + " = keyframes`" + R.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + O + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + h + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + h + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var v = r[n];
  return v !== void 0 ? v : n;
}
function Yn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      a += Te(e, r, n[i]) + ";";
  else
    for (var s in n) {
      var d = n[s];
      if (typeof d != "object")
        r != null && r[d] !== void 0 ? a += s + "{" + r[d] + "}" : Wr(d) && (a += sr(s) + ":" + Ue(s, d) + ";");
      else {
        if (s === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(lt);
        if (Array.isArray(d) && typeof d[0] == "string" && (r == null || r[d[0]] === void 0))
          for (var f = 0; f < d.length; f++)
            Wr(d[f]) && (a += sr(s) + ":" + Ue(s, d[f]) + ";");
        else {
          var h = Te(e, r, d);
          switch (s) {
            case "animation":
            case "animationName": {
              a += sr(s) + ":" + h + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && s === "undefined" && console.error(kn), a += s + "{" + h + "}";
          }
        }
      }
    }
  return a;
}
var Gr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, dt;
process.env.NODE_ENV !== "production" && (dt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Z, Hr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var i = !0, s = "";
  Z = void 0;
  var d = r[0];
  d == null || d.raw === void 0 ? (i = !1, s += Te(a, n, d)) : (process.env.NODE_ENV !== "production" && d[0] === void 0 && console.error(Ur), s += d[0]);
  for (var f = 1; f < r.length; f++)
    s += Te(a, n, r[f]), i && (process.env.NODE_ENV !== "production" && d[f] === void 0 && console.error(Ur), s += d[f]);
  var h;
  process.env.NODE_ENV !== "production" && (s = s.replace(dt, function(R) {
    return h = R, "";
  })), Gr.lastIndex = 0;
  for (var v = "", p; (p = Gr.exec(s)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    p[1];
  var g = Sn(s) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: g,
    styles: s,
    map: h,
    next: Z,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: g,
    styles: s,
    next: Z
  };
}, zn = function(r) {
  return r();
}, Bn = te["useInsertionEffect"] ? te["useInsertionEffect"] : !1, Un = Bn || zn, He = {}.hasOwnProperty, br = /* @__PURE__ */ te.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ _n({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (br.displayName = "EmotionCacheContext");
br.Provider;
var Wn = function(r) {
  return /* @__PURE__ */ hr(function(n, a) {
    var i = Lt(br);
    return r(n, i, a);
  });
}, pt = /* @__PURE__ */ te.createContext({});
process.env.NODE_ENV !== "production" && (pt.displayName = "EmotionThemeContext");
var Jr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, qn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Jr(n[1]);
}, Gn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Hn = function(r) {
  return r.replace(/\$/g, "-");
}, Jn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var i = qn(n[a]);
      if (i) {
        if (Gn.has(i))
          break;
        if (/^[A-Z]/.test(i))
          return Hn(i);
      }
    }
}, dr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", pr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", ht = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var i in n)
    He.call(n, i) && (a[i] = n[i]);
  if (a[dr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var s = Jn(new Error().stack);
    s && (a[pr] = s);
  }
  return a;
}, Kn = function(r) {
  var n = r.cache, a = r.serialized, i = r.isStringTag;
  return ut(n, a, i), Un(function() {
    return Nn(n, a, i);
  }), null;
}, yt = /* @__PURE__ */ Wn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var i = e[dr], s = [a], d = "";
  typeof e.className == "string" ? d = Pn(r.registered, s, e.className) : e.className != null && (d = e.className + " ");
  var f = Hr(s, void 0, te.useContext(pt));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var h = e[pr];
    h && (f = Hr([f, "label:" + h + ";"]));
  }
  d += r.key + "-" + f.name;
  var v = {};
  for (var p in e)
    He.call(e, p) && p !== "css" && p !== dr && (process.env.NODE_ENV === "production" || p !== pr) && (v[p] = e[p]);
  return v.ref = n, v.className = d, /* @__PURE__ */ te.createElement(te.Fragment, null, /* @__PURE__ */ te.createElement(Kn, {
    cache: r,
    serialized: f,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ te.createElement(i, v));
});
process.env.NODE_ENV !== "production" && (yt.displayName = "EmotionCssPropInternal");
var vt = yt;
function ne(e, r, n) {
  return He.call(r, "css") ? ze.jsx(vt, ht(e, r), n) : ze.jsx(e, r, n);
}
function Zn(e, r, n) {
  return He.call(r, "css") ? ze.jsxs(vt, ht(e, r), n) : ze.jsxs(e, r, n);
}
function Xn(e, r) {
  return b`
    ${e ? b`
          width: 100%;
        ` : null};
    ${r ? b`
          height: 100%;
        ` : null};
    transition: color 200ms ease-in-out, background-color 200ms ease-in-out;
    vertical-align: middle;
    white-space: nowrap;
    outline: none;
    border: 0;
    background-color: transparent;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `;
}
var w;
(function(e) {
  e[e.DEFAULT = 0] = "DEFAULT", e[e.HOVER = 1] = "HOVER", e[e.ACTIVE = 2] = "ACTIVE", e[e.DISABLE = 3] = "DISABLE";
})(w || (w = {}));
function $(e, r, n) {
  switch (n) {
    case w.DEFAULT:
      switch (r) {
        case "fill":
          return e === "white" ? [u("white", "01"), u("gray", "02")] : e != "gray" && e != "grayBlue" ? [u(e, "01"), u("white", "01")] : [u(e, "09"), u(e, "02")];
        case "light":
          return e === "white" ? [u("white", "01"), u("gray", "02")] : [u(e, "07"), u(e, "01")];
        case "dashed":
        case "outline":
          return e == "white" ? [u("white", "01"), u("white", "01")] : e != "gray" && e != "grayBlue" ? [u(e, "01"), u(e, "01")] : [u(e, "08"), u(e, "02")];
        case "text":
          return e == "white" ? [u("transparent", "01"), u("gray", "02")] : [u("transparent", "01"), u(e, "01")];
      }
    case w.HOVER:
      switch (r) {
        case "fill":
          return e == "white" ? [u("white", "02"), u("gray", "02")] : e != "gray" && e != "grayBlue" ? [u(e, "02"), u("white", "01")] : [u(e, "08"), u(e, "02")];
        case "light":
          return e == "white" ? [u("white", "02"), u("gray", "02")] : [u(e, "06"), u(e, "01")];
        case "dashed":
        case "outline":
          return e == "white" ? [u("white", "02"), u("gray", "02")] : e != "gray" && e != "grayBlue" ? [u(e, "02"), u(e, "02")] : [u(e, "07"), u(e, "02")];
        case "text":
          return e == "white" ? [u("white", "02"), u("gray", "02")] : [u("grayBlue", "09"), u(e, "02")];
      }
    case w.ACTIVE:
      switch (r) {
        case "fill":
          return e == "white" ? [u("white", "03"), u("gray", "02")] : e != "gray" && e != "grayBlue" ? [u(e, "n-01"), u("white", "01")] : [u(e, "06"), u(e, "02")];
        case "light":
          return e == "white" ? [u("white", "02"), u("gray", "02")] : [u(e, "05"), u(e, "01")];
        case "dashed":
        case "outline":
          return e == "white" ? [u("white", "03"), u("gray", "02")] : e != "gray" && e != "grayBlue" ? [
            u(e, "n-01"),
            u(e, "n-01")
          ] : [u(e, "05"), u(e, "02")];
        case "text":
          return e == "white" ? [u("white", "03"), u("gray", "02")] : [u("grayBlue", "08"), u(e, "n-01")];
      }
    case w.DISABLE:
      switch (r) {
        case "fill":
          return e == "white" ? [u("white", "04"), u("gray", "02")] : e != "gray" && e != "grayBlue" ? [u(e, "05"), u("white", "01")] : [u(e, "09"), u(e, "05")];
        case "light":
          return e == "white" ? [u("white", "04"), u("gray", "02")] : [u(e, "07"), u(e, "05")];
        case "dashed":
        case "outline":
          return e == "white" ? [u("white", "04"), u("gray", "02")] : e != "gray" && e != "grayBlue" ? [u(e, "05"), u(e, "05")] : [u(e, "08"), u(e, "05")];
        case "text":
          return e == "white" ? [u("white", "04"), u("gray", "02")] : [u("transparent", "01"), u(e, "05")];
      }
  }
  return [];
}
function Qn(e, r) {
  switch (e) {
    case "text":
      return b`
        &:hover {
          background-color: ${$(r, e, w.HOVER)[0]};
        }

        &:active {
          transition: none;
          background-color: ${$(r, e, w.ACTIVE)[0]};
        }
      `;
    case "dashed":
      return b`
        border: dashed 1px
          ${$(r, e, w.DEFAULT)[0]};

        &:hover {
          border: dashed 1px
            ${$(r, e, w.HOVER)[0]};
        }

        &:active {
          transition: none;
          border: dashed 1px
            ${$(r, e, w.ACTIVE)[0]};
        }

        &:disabled {
          border: dashed 1px
            ${$(r, e, w.DISABLE)[0]};
        }
      `;
    case "fill":
      return b`
        background-color: ${$(r, e, w.DEFAULT)[0]};

        &:hover {
          background-color: ${$(r, e, w.HOVER)[0]};
        }

        &:active {
          transition: none;
          background-color: ${$(r, e, w.ACTIVE)[0]};
        }

        &:disabled {
          background-color: ${$(r, e, w.DISABLE)[0]};
        }
      `;
    case "outline":
      return b`
        border: solid 1px
          ${$(r, e, w.DEFAULT)[0]};

        &:hover {
          border: solid 1px
            ${$(r, e, w.HOVER)[0]};
        }

        &:active {
          transition: none;
          border: solid 1px
            ${$(r, e, w.ACTIVE)[0]};
        }

        &:disabled {
          border: solid 1px
            ${$(r, e, w.DISABLE)[0]};
        }
      `;
    case "light":
      return b`
        background-color: ${$(r, e, w.DEFAULT)[0]};

        &:hover {
          background-color: ${$(r, e, w.HOVER)[0]};
        }

        &:active {
          transition: none;
          background-color: ${$(r, e, w.ACTIVE)[0]};
        }

        &:disabled {
          background-color: ${$(r, e, w.DISABLE)[0]};
        }
      `;
  }
}
function ea(e) {
  return e ? b`
      cursor: default;

      &:disabled {
        cursor: not-allowed;
      }
    ` : b`
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
      }
    `;
}
function ra(e, r) {
  switch (e) {
    case "text":
      return b`
        color: ${$(r, e, w.DEFAULT)[1]};

        &:disabled {
          color: ${$(r, e, w.DISABLE)[1]};
        }
      `;
    case "light":
      return b`
        color: ${$(r, e, w.DEFAULT)[1]};

        &:hover {
          color: ${$(r, e, w.HOVER)[1]};
        }

        &:active {
          transition: none;
          color: ${$(r, e, w.ACTIVE)[1]};
        }

        &:disabled {
          color: ${$(r, e, w.DISABLE)[1]};
        }
      `;
    case "outline":
    case "dashed":
      return b`
        color: ${$(r, e, w.DEFAULT)[1]};

        &:hover {
          color: ${$(r, e, w.HOVER)[1]};
        }

        &:active {
          transition: none;
          color: ${$(r, e, w.ACTIVE)[1]};
        }

        &:disabled {
          color: ${$(r, e, w.DISABLE)[1]};
        }
      `;
    case "fill":
      return b`
        color: ${$(r, e, w.DEFAULT)[1]};

        &:hover {
          color: ${$(r, e, w.HOVER)[1]};
        }

        &:active {
          transition: none;
          color: ${$(r, e, w.ACTIVE)[1]};
        }

        &:disabled {
          color: ${$(r, e, w.DISABLE)[1]};
        }
      `;
  }
  return b``;
}
function ta(e, r, n, a) {
  switch (e) {
    case "square":
      return r ? n ? b`
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
          ` : a ? b`
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          ` : b`
            border-radius: 0;
          ` : b`
        border-radius: 8px;
      `;
    case "round":
      return r ? n ? b`
            border-top-left-radius: 999px;
            border-bottom-left-radius: 999px;
          ` : a ? b`
            border-top-right-radius: 999px;
            border-bottom-right-radius: 999px;
          ` : b`
            border-radius: 0;
          ` : b`
          border-radius: 999px;
        `;
  }
}
function na(e, r) {
  switch (e) {
    case "small":
      return b`
        padding: ${r == "outline" || r == "dashed" ? "1px 7px" : "2px 8px"};
      `;
    case "medium":
      return b`
        padding: ${r == "outline" || r == "dashed" ? "4px 15px" : "5px 16px"};
      `;
    case "large":
      return b`
        padding: ${r == "outline" || r == "dashed" ? "8px 15px" : "9px 16px"};
      `;
  }
}
function aa(e, r, n) {
  switch (e) {
    case "small":
      return b`
        justify-content: center;
        width: ${r ? "100%" : "24px"};
        height: ${n ? "100%" : "24px"};
        font-size: 12px;
      `;
    case "medium":
      return b`
        justify-content: center;
        width: ${r ? "100%" : "32px"};
        height: ${n ? "100%" : "32px"};
        font-size: 12px;
      `;
    case "large":
      return b`
        justify-content: center;
        width: ${r ? "100%" : "40px"};
        height: ${n ? "100%" : "40px"};
        font-size: 12px;
      `;
  }
}
function ia(e) {
  switch (e) {
    case "small":
      return b`
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
      `;
    case "medium":
    case "large":
      return b`
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 22px;
        letter-spacing: normal;
      `;
  }
}
function sa(e) {
  switch (e) {
    case "small":
      return b`
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        margin-right: 4px;
      `;
    case "medium":
    case "large":
      return b`
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        margin-right: 4px;
      `;
  }
}
function Kr(e) {
  switch (e) {
    case "small":
    case "medium":
    case "large":
      return b`
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      `;
  }
}
function oa(e) {
  switch (e) {
    case "small":
      return b`
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        margin-left: 6px;
      `;
    case "medium":
    case "large":
      return b`
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        margin-left: 8px;
      `;
  }
}
const ca = b`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`;
function ua(e, r, n) {
  return n ? b`
      display: inline-flex;
      margin-left: ${r != 0 ? "-1px" : "0px"};

      &:hover {
        z-index: ${Dr.button};
      }
    ` : b`
      display: inline-flex;
      margin-left: ${r == 0 ? "0px" : e};

      &:hover {
        z-index: ${Dr.button};
      }
    `;
}
const fa = hr((e, r) => ne(xr.Consumer, { children: (n) => {
  const { attached: a, first: i, last: s } = n ?? {}, { colorScheme: d = (n == null ? void 0 : n.colorScheme) ?? "blue", size: f = (n == null ? void 0 : n.size) ?? "medium", variant: h = (n == null ? void 0 : n.variant) ?? "fill", shape: v = (n == null ? void 0 : n.shape) ?? "square", fullWidth: p, fullHeight: g, loading: R, loadingText: O, leftIcon: I, disabled: x, rightIcon: M, onClick: _, ...m } = e, k = O != null && O.length > 0, c = or.count(e.children) >= 1 || k && R, Y = b`
            ${Xn(p, g)};
            ${ea(R ?? !1)}
            ${c ? na(f, h) : aa(f, p, g)};
            ${ta(v, a ?? !1, i ?? !1, s ?? !1)};
            ${ra(h, d)};
            ${Qn(h, d)};
          `;
  return Zn("button", { ref: r, css: [Y, Xr(m)], onClick: (A) => {
    x || R || _ == null || _(A);
  }, disabled: x || R, ...Qr(m), children: [(R || I) && ne("span", { css: c ? sa(f) : Kr(f), children: R ? ne(Mt, { spin: !0 }) : I }), c && ne("span", { css: ia(f), children: R && O ? O : e.children }), M && ne("span", { css: c ? oa(f) : Kr(f), children: M })] });
} }));
fa.displayName = "Button";
const xr = Vt(void 0);
xr.displayName = "ButtonGroupContext";
const la = hr((e, r) => {
  const { colorScheme: n = "blue", size: a = "medium", variant: i = "fill", shape: s = "square", spacing: d = "4px", attached: f, ...h } = e, v = or.map(e.children, (p, g) => {
    const R = g == 0, O = g == or.count(e.children) - 1;
    return ne(xr.Provider, { value: {
      colorScheme: n,
      size: a,
      variant: i,
      shape: s,
      spacing: d,
      attached: f,
      first: R,
      last: O
    }, children: ne("span", { css: ua(d, g, f ?? !1), children: p }) });
  });
  return ne("div", { css: [ca, Xr(e)], ref: r, ...Qr(h), children: v });
});
la.displayName = "ButtonGroup";
export {
  fa as Button,
  la as ButtonGroup,
  xr as ButtonGroupContext
};
//# sourceMappingURL=index.js.map
